import React, { useState } from "react";
//primereact
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
//components
import Input from "../input/Input";
import Select from "../input/Select";
import MaskInput from "../input/MaskInput";
import CreditCard from "./CreditCard";
import { Controller } from "react-hook-form";
import ReactInputMask from "react-input-mask";

const PaymentMethods = ({
  pix,
  card,
  form,
  formPix,
  cardState,
  installment,
  onSubmitPix,
  paymentMethod,
  setCardMonthly,
  cardInstallment,
  setPaymentMethod,
  handleInputFocus,
  creditCardClient,
  handleInputChange,
  visibleCreditCard,
  setCardInstallment,
  handleMonthlyFocus,
  creditCardSelected,
  setActiveIndexModal,
  setCreditCardClient,
  optionsInstallments,
  setVisibleCreditCard,
  setCreditCardSelected,
  visiblePaymentMethods,
  handleInstallmentFocus,
  handleInstallmentChange,
  setVisiblePaymentMethods,
  setVisibleModalCreditCard,
  handleSelectPaymentMethod,
}) => {
  const [doc, setDoc] = useState("");
  const [mask, setMask] = useState("99.999.999/9999-99");
  
  const cardBrandIcon = {
    visa: "fa-brands fa-cc-visa",
    mastercard: "fa-brands fa-cc-mastercard",
    amex: "fa-brands fa-cc-amex",
    discover: "fa-brands fa-cc-discover",
    diners: "fa-brands fa-cc-diners-club",
    jcb: "fa-brands fa-cc-jcb",
    maestro: "fa-brands fa-cc-maestro",
    unknown: "fa-regular fa-credit-card",
  };

  const getCardBrand = (number) => {
    const cleanNumber = number.replace(/\s+/g, "");
    const cardPatterns = {
      visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
      mastercard: /^5[1-5][0-9]{14}$/,
      amex: /^3[47][0-9]{13}$/,
      discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
      diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
      jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
      maestro: /^(?:5[06789]\d\d|6\d{3})\d{12,15}$/,
    };

    for (let brand in cardPatterns) {
      if (cardPatterns[brand].test(cleanNumber)) {
        return brand;
      }
    }

    return "unknown";
  };

  const watchMask = (value) => {
    if (value.length <= 14) {
      setMask("999.999.999-999");
      setDoc(value);
    } else {
      setMask("99.999.999/9999-99");
      setDoc(value);
    }
  };

  const maskCardNumber = (number) => {
    return number
      .split(" ")
      .map((group, index, arr) => {
        if (index === 0 || index === arr.length - 1) {
          return group; // Keep first and last group unchanged
        }
        return group.replace(/\d/g, "*"); // Mask other groups
      })
      .join(" ");
  };

  return (
    <>
      {visiblePaymentMethods &&
      (paymentMethod === null ||
        paymentMethod === "pix" ||
        (paymentMethod === "card" && cardState.card_number !== "") ||
        (paymentMethod === "installment" &&
          cardInstallment.card_number !== "")) ? (
        <>
          {card && (
            <div
              className={`card-payment-method ${
                paymentMethod === "card" && cardState.card_number !== ""
                  ? "card-payment-method-selected"
                  : ""
              } border rounded d-flex justify-content-start align-items-center p-3 my-2`}
              onClick={() => handleSelectPaymentMethod("card")}
            >
              <RadioButton
                name="card"
                value={"card"}
                onChange={(e) => handleSelectPaymentMethod(e.value)}
                checked={paymentMethod === "card"}
              />
              <i
                className={`${
                  cardState.card_number !== ""
                    ? cardBrandIcon[getCardBrand(cardState.card_number)]
                    : "fa-regular fa-credit-card"
                } mx-3`}
              ></i>
              <h5 className="mt-2">
                {cardState.card_number !== ""
                  ? maskCardNumber(cardState.card_number)
                  : "Adicionar Cartão"}
              </h5>
            </div>
          )}
          {pix && (
            <div
              className={`card-payment-method ${
                paymentMethod === "pix" ? "card-payment-method-selected" : ""
              } border rounded d-flex justify-content-start align-items-center p-3 my-2`}
              onClick={() => handleSelectPaymentMethod("pix")}
            >
              <RadioButton
                name="pix"
                value={"pix"}
                onChange={(e) => handleSelectPaymentMethod(e.value)}
                checked={paymentMethod === "pix"}
              />
              <i className="fa-brands fa-pix mx-3"></i>
              <h5 className="mt-2">Pix</h5>
            </div>
          )}
          {installment && (
            <div
              className={`card-payment-method ${
                paymentMethod === "installment"
                  ? "card-payment-method-selected"
                  : ""
              } border rounded d-flex justify-content-start align-items-center p-3 my-2`}
              onClick={() => handleSelectPaymentMethod("installment")}
            >
              <RadioButton
                name="installment"
                value={"installment"}
                onChange={(e) => handleSelectPaymentMethod(e.value)}
                checked={paymentMethod === "installment"}
              />
              <i className="fa-regular fa-credit-card mx-3"></i>
              <h5 className="mt-2">Pagamento Parcelado</h5>
            </div>
          )}
        </>
      ) : (
        <>
          {paymentMethod === "card" && (
            <>
              <div className="d-flex justify-content-end">
                <Button
                  outlined
                  type="button"
                  className="mb-3"
                  onClick={() => {
                    setVisiblePaymentMethods(true);
                    setPaymentMethod(
                      cardState.card_number !== "" ? "card" : null
                    );
                  }}
                  label="Voltar"
                  icon="fa-solid fa-arrow-left"
                />
              </div>
              <CreditCard
                state={cardState}
                handleInputChange={handleInputChange}
                handleInputFocus={handleInputFocus}
                onClickData={() => {
                  setVisibleModalCreditCard(true);
                  setActiveIndexModal(0);
                }}
                onClickAddress={() => {
                  setVisibleModalCreditCard(true);
                  setActiveIndexModal(1);
                }}
                clientData={creditCardClient?.data && creditCardClient?.data}
                clientAddress={
                  creditCardClient?.address && creditCardClient?.address
                }
              />
              <div className="d-flex justify-content-end">
                <Button
                  type="button"
                  className="mb-3"
                  disabled={
                    !creditCardClient &&
                    !creditCardClient?.data &&
                    !creditCardClient?.address
                  }
                  onClick={() => {
                    setVisiblePaymentMethods(true);
                    if (setCardMonthly) {
                      setCardMonthly(cardState);
                    }
                    if (handleMonthlyFocus) {
                      handleMonthlyFocus("number");
                    }
                    form.setValue("installments", null);
                  }}
                  label="Salvar"
                  icon="fa-solid fa-check"
                />
              </div>
            </>
          )}
          {paymentMethod === "pix" && (
            <>
              <div className="d-flex justify-content-end">
                <Button
                  outlined
                  type="button"
                  className="mb-3"
                  onClick={() => {
                    setVisiblePaymentMethods(true);
                    setPaymentMethod(null);
                  }}
                  label="Voltar"
                  icon="fa-solid fa-arrow-left"
                />
              </div>
              <h4 className="">Dados para pagamento via pix</h4>
              <form onSubmit={formPix.handleSubmit(onSubmitPix)}>
                <div className="row">
                  <div className="col-md-6">
                    <Input
                      isRequired
                      type="text"
                      control={formPix.control}
                      errors={formPix.formState.errors}
                      label="Nome *"
                      name="customer_name"
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-6">
                    {/* <MaskInput
                      name={`customer_doc`}
                      mask="999.999.999-99"
                      control={formPix.control}
                      isRequired
                      errors={formPix.formState.errors}
                      label={`CPF *`}
                    /> */}
                    <Controller
                      name="customer_doc"
                      control={formPix.control}
                      defaultValue=""
                      rules={{ required: "CPF / CNPJ é obrigatório" }}
                      render={({ field, fieldState }) => (
                        <>
                          <ReactInputMask
                            {...field}
                            mask={mask}
                            maskChar={null}
                            placeholder="CPF / CNPJ *"
                            className={`input-cpf ${
                              fieldState.error ? "input-error" : ""
                            } ${doc ? "input-filled" : ""}`}
                            onChange={(event) => {
                              field.onChange(event.target.value);
                              watchMask(event.target.value);
                            }}
                          />
                          {fieldState.error && (
                            <span className="p-error">
                              {fieldState.error.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <Input
                      isRequired
                      name="customer_email"
                      errors={formPix.formState.errors}
                      control={formPix.control}
                      type="email"
                      validationRules={{
                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "E-mail inválido.",
                        },
                      }}
                      label="E-mail *"
                    />
                  </div>
                  <div className="col-md-6">
                    <MaskInput
                      name={`phone_pix`}
                      mask="(99) 99999-999?9"
                      control={formPix.control}
                      isRequired
                      errors={formPix.formState.errors}
                      label={`Telefone *`}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <Button
                    type="submit"
                    className="mb-3"
                    label="Salvar"
                    icon="fa-solid fa-check"
                  />
                </div>
              </form>
            </>
          )}
          {paymentMethod === "installment" && (
            <>
              <div className="d-flex justify-content-end">
                <Button
                  outlined
                  type="button"
                  className="mb-3"
                  onClick={() => {
                    setVisiblePaymentMethods(true);
                    setPaymentMethod(null);
                  }}
                  label="Voltar"
                  icon="fa-solid fa-arrow-left"
                />
              </div>
              <h4>Selecione um Cartão de crédito</h4>
              {cardState.card_number !== "" && (
                <div
                  className={`card-payment-method ${
                    creditCardSelected === "card" &&
                    cardState.card_number !== ""
                      ? "card-payment-method-selected"
                      : ""
                  } border rounded d-flex justify-content-start align-items-center p-3 my-3`}
                  onClick={() => {
                    setCreditCardSelected("card");
                    // setCardInstallment(cardState);
                    setVisibleCreditCard(false);
                  }}
                >
                  <RadioButton
                    name="card"
                    value={"card"}
                    onChange={(e) => {
                      setCreditCardSelected("card");
                      // setCardInstallment(cardState);
                      setVisibleCreditCard(false);
                    }}
                    checked={creditCardSelected === "card"}
                  />
                  <i
                    className={`${
                      cardState.card_number !== ""
                        ? cardBrandIcon[getCardBrand(cardState.card_number)]
                        : "fa-regular fa-credit-card"
                    } mx-3`}
                  ></i>
                  <h5 className="mt-2">
                    {cardState.card_number !== ""
                      ? maskCardNumber(cardState.card_number)
                      : ""}
                  </h5>
                </div>
              )}
              <div
                className={`card-payment-method ${
                  creditCardSelected === "cardInstallment" &&
                  cardInstallment.card_number !== ""
                    ? "card-payment-method-selected"
                    : ""
                } border rounded d-flex justify-content-start align-items-center p-3 my-3`}
                onClick={() => {
                  setVisibleCreditCard(true);
                  setCreditCardSelected("cardInstallment");
                }}
              >
                <RadioButton
                  name="card"
                  value={"cardInstallment"}
                  onChange={(e) => {
                    setVisibleCreditCard(true);
                    setCreditCardSelected("cardInstallment");
                    setCreditCardClient(null);
                  }}
                  checked={creditCardSelected === "cardInstallment"}
                />
                <i
                  className={`${
                    cardInstallment.card_number !== ""
                      ? cardBrandIcon[getCardBrand(cardInstallment.card_number)]
                      : "fa-regular fa-credit-card"
                  } mx-3`}
                ></i>
                <h5 className="mt-2">
                  {cardInstallment.card_number !== ""
                    ? maskCardNumber(cardInstallment.card_number)
                    : "Adicionar Cartão"}
                </h5>
              </div>
              {visibleCreditCard && (
                <CreditCard
                  state={cardInstallment}
                  handleInputChange={handleInstallmentChange}
                  handleInputFocus={handleInstallmentFocus}
                  onClickData={() => {
                    setVisibleModalCreditCard(true);
                    setActiveIndexModal(0);
                  }}
                  onClickAddress={() => {
                    setVisibleModalCreditCard(true);
                    setActiveIndexModal(1);
                  }}
                  clientData={creditCardClient?.data && creditCardClient?.data}
                  clientAddress={
                    creditCardClient?.address && creditCardClient?.address
                  }
                />
              )}
              <h4>Defina quantas prestações</h4>
              <Select
                name="installments"
                label="Número de prestações"
                control={form.control}
                options={optionsInstallments}
                errors={form.formState.errors}
              />
              <div className="d-flex justify-content-end">
                <Button
                  type="button"
                  className="my-3"
                  onClick={() => {
                    setVisiblePaymentMethods(true);
                    setPaymentMethod("installment");

                    if (creditCardSelected === "card") {
                      setCardInstallment(cardState);
                    }

                    if (creditCardSelected === "cardInstallment") {
                      setCardMonthly(cardInstallment);
                    }

                    handleMonthlyFocus("number");
                  }}
                  label="Salvar"
                  icon="fa-solid fa-check"
                />
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default PaymentMethods;
